/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><div :class="({'scramble-footer': isFromScramble})" class="footer-content" v-if="(!isDetailShow && (changeTip || !licenseCheckedDefault && reminders != null))"><div class="change-tip" v-if="(changeTip)">{{ changeTip }}</div><template v-else-if="(!licenseCheckedDefault && reminders != null)"><mpx-view @tap="licenseClick" :style='[("padding-top:"+(paddingTop)+";")] | transRpxStyle'><es-checkbox label-position="right" custom-class="custom-class" name="1" :value="(licenseAgreementSelected)" shap="square" :icon-style="(checkboxIconWrapStyle)" useIconSlot><es-icon slot="icon" size="8" name="check-filled" :style="[(checkboxIconStyle)] | transRpxStyle"/></es-checkbox></mpx-view><div><mpx-view :class="({'scramble-text': isFromScramble, 'text-color': licenseAgreementSelected})" @tap="licenseClick" class="protocol protocol-text">{{ reminders != null ? reminders.purchase_service : '' }}</mpx-view><mpx-view :class="({'scramble-url': isFromScramble, 'url-color': !licenseAgreementSelected})" @tap="jumpToH5(item, index)" v-for="(item, index) in (purchaseList)" class="protocol protocol-url">《{{ item.name }}》</mpx-view></div></template></div><pay-bottom-bar :canPay="(canPay)" isMakeOrder :showDealAlert="(isDetailShow)" :totalFeeInfo="(totalFeeInfo)" :payType="(1)" :isFromScramble="(isFromScramble)" @pay="submitOrder" @scramblePay="submitScrambleOrder" @submit="submitOrder" @click="changeDetail" :studentLength="(studentLength)" :isExemption="(isExemption)"/></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m5fbed49e"}'>
  @import '~@/mixins/stylus/color.styl'

  .custom-class
    align-items normal !important
  .footer-content
    display flex
    flex-direction row
    align-items flex-start
    padding 8px 16px
    background-image linear-gradient(270deg, #ffffff 0%, #edf4ff 100%)
    .change-tip
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      line-height 14px
      letter-spacing 0px
      color #999999
    .text-color
      color $train-color-999
    .url-color 
      color #FF6400
  .scramble-footer
    background-image linear-gradient(270deg, #FEFEFE -7%, #FEF7EF 99%)
  .card-button
    font-size 16px
    font-weight bold
    text-align center
    color white
    border-width 0px
    border-radius 8px
    background-color $train-color-theme-orange
    font-family PingFangSC-Regular
    font-weight 400
  .protocol
    font-size 12px
    display inline
    color #666666
    &.text
      color $train-color-999
    &.url
      color $train-color-333
      text-overflow ellipsis
  .scramble-text
    color #999
  .scramble-url
    color #333
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m5fbed49e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./order-bottom-bar.mpx.js?isComponent&outputPath=components%2Forder-bottom-bar5fbed49e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./order-bottom-bar.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Forder-bottom-bar5fbed49e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m5fbed49e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/order-bottom-bar5fbed49e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'pay-bottom-bar':getComponent(require("../../order/components/order-detail-pay-bottom-bar.mpx?isComponent&outputPath=components%2Forder-detail-pay-bottom-barc05e99a0%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
